<div class="summaryCardDs__cont summaryCardDs__cont--{{type}}">
  <ng-container *ngIf="header">
    <div class="summaryCardDs__header summaryCardDs__header--{{type}}">
      <div class="summaryCardDs__header-info">
        <div class="summaryCardDs__header-info-left">
          <ng-container *ngIf="header.Icon">
            <div class="summaryCardDs__header-info-icon">
              <app-ds-icon
                [icon]="header.Icon"
                [size]="16">
              </app-ds-icon>
            </div>
          </ng-container>
          <div class="summaryCardDs__header-info-text">
            <app-ds-typography
              [size]="fontSize.XXXS"
              [color]="fontColor.Primary"
              [fontFamily]="fontFamily.SemiBold"
              [text]="header.Title">
            </app-ds-typography>
            <ng-container *ngIf="header.Description">
              <app-ds-typography
                [size]="fontSize.XXXS"
                [color]="fontColor.Primary"
                [text]="': ' + header.Description">
              </app-ds-typography>
            </ng-container>
          </div>
        </div>
        <ng-container *ngIf="header.Action">
          <div class="summaryCardDs__header-info-right">
            <app-ds-button-link
              [type]="buttonLinkType.Secondary"
              [iconPosition]="buttonLinkIconPosition.Right"
              [fontSize]="fontSize.XXXS"
              [icon]="header.Action.Icon"
              [iconSize]="16"
              [label]="header.Action.Label"
              (clickEvent)="headerEvent.emit()">
            </app-ds-button-link>
          </div>
        </ng-container>
      </div>
      <div class="summaryCardDs__header-divider">
        <app-ds-divider></app-ds-divider>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="image">
    <div class="summaryCardDs__image summaryCardDs__image--{{type}}">
      <app-ds-image
        [width]="'100%'"
        [height]="'176px'"
        [alt]="image"
        [src]="image"
        [size]="imageSize"
        [useLoader]="true">
      </app-ds-image>
    </div>
  </ng-container>
  <div class="summaryCardDs__options summaryCardDs__options--{{type}}">
    <div class="summaryCardDs__options-title">
      <app-ds-typography
        [size]="titleFontSize"
        [color]="fontColor.Primary"
        [fontFamily]="fontFamily.SemiBold"
        [text]="title">
      </app-ds-typography>
    </div>
    <div class="summaryCardDs__options-divider summaryCardDs__options-divider--{{type}}">
      <app-ds-divider></app-ds-divider>
    </div>
    <ng-container *ngIf="options?.length">
      <div class="summaryCardDs__options-grid summaryCardDs__options-grid--{{type}}">
        <ng-container *ngFor="let option of options; trackBy: trackById">
          <div class="summaryCardDs__options-grid-option summaryCardDs__options-grid-option--{{type}}" [ngStyle]="{
            gridColumn: option.GridSpan && 'span ' + option.GridSpan
          }">
            <ng-container *ngIf="enabledTitle(option)">
              <app-ds-typography
                [tag]="'h4'"
                [size]="fontSize.XXS"
                [color]="fontColor.Primary"
                [fontFamily]="fontFamily.SemiBold"
                [text]="option.Title">
              </app-ds-typography>
            </ng-container>
            <div class="summaryCardDs__options-grid-option-description">
              <ng-container *ngIf="enabledIcon(option)">
                <div class="summaryCardDs__options-grid-option-description-icon">
                  <app-ds-icon
                    [icon]="option.Icon"
                    [size]="16">
                  </app-ds-icon>
                </div>
              </ng-container>
              <app-ds-typography
                [tag]="'p'"
                [size]="fontSize.XXS"
                [color]="fontColor.Primary"
                [text]="option.Description">
              </app-ds-typography>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>